module.exports = __webpack_public_path__ + "static/media/Sun-5_moon-5.d0575d6b.png";